import React, { useState, useEffect, useRef } from "react";
import Chat from "./chat";
import { Mail, Phone, X } from "lucide-react";

export default function CustomerService({ setOpenMenu }) {
  const [openChat, _setOpenChat] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setOpenMenu]);

  return (
    <div ref={menuRef} className="floating-card">
      <div className="floating-card__header">
        <p className="header">
          <br /> נשמח לעזור
        </p>
        <button
          type="button"
          className="floating-card__close"
          onClick={() => setOpenMenu(false)}
          aria-label="סגירה"
        >
          <X aria-hidden size={18} strokeWidth={2} />
        </button>
      </div>
      <a
        href={`https://mail.google.com/mail/?view=cm&fs=1&to=s@hamazon.co.il&su=פנייה%20מאתר%20החברה`}
        onClick={() => setOpenMenu(false)}
        target="_blank"
        className="option"
        rel="noreferrer"
      >
        <span className="option__icon" aria-hidden>
          <Mail size={18} strokeWidth={2} />
        </span>
        <span className="option__text">
          <span className="option__label">בדוא&quot;ל</span>
          <span className="option__value">s@hamazon.co.il</span>
        </span>
      </a>
      <a
        href="tel:+97225327277"
        target="_blank"
        className="option"
        onClick={() => setOpenMenu(false)}
        rel="noreferrer"
      >
        <span className="option__icon" aria-hidden>
          <Phone size={18} strokeWidth={2} />
        </span>
        <span className="option__text">
          <span className="option__label">בטלפון</span>
          <span className="option__value">02-5327-277</span>
        </span>
      </a>
      {openChat ? <Chat setOpenMenu={setOpenMenu} /> : null}
    </div>
  );
}
